import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
    selector: 'app-header',
    templateUrl: 'header.component.html',
    styleUrls: ['header.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HeaderComponent {}
